// Block Blast tarzı için temel şekil tanımları
// Her şekil: 2D dizi (1: dolu, 0: boş)
export const SHAPES = [
  // Tek blok
  [[1]],
  // İki yatay
  [[1, 1]],
  // Üç yatay
  [[1, 1, 1]],
  // Dört yatay
  [[1, 1, 1, 1]],
  // İki dikey
  [[1], [1]],
  // Üç dikey
  [[1], [1], [1]],
  // Dört dikey
  [[1], [1], [1], [1]],
  // Kare 2x2
  [
    [1, 1],
    [1, 1],
  ],
  // L şekli
  [
    [1, 0],
    [1, 0],
    [1, 1],
  ],
  // T şekli
  [
    [1, 1, 1],
    [0, 1, 0],
  ],
  // Z şekli
  [
    [1, 1, 0],
    [0, 1, 1],
  ],
  // S şekli
  [
    [0, 1, 1],
    [1, 1, 0],
  ],
  // L ters
  [
    [0, 1],
    [0, 1],
    [1, 1],
  ],
];